import { Key } from 'ts-keycode-enum';
import { applyChanges } from '../../utils/changes';
var Direction;
(function (Direction) {
    Direction["Left"] = "left";
    Direction["Right"] = "right";
})(Direction || (Direction = {}));
export class SegmentedControlState {
    constructor(setState) {
        this.props = {
            items: [],
            currentItemValue: undefined
        };
        this.state = Object.assign({}, SegmentedControlState.initialState);
        this.listeners = {
            onChange: undefined
        };
        this.setState = (changes = {}) => {
            setState((prevState = {}) => {
                return Object.assign(Object.assign({}, prevState), changes);
            });
        };
    }
    onDidMount() {
    }
    onWillUnmount() {
    }
    getNextItem(currentIndex, direction) {
        var _a;
        let nextIndex = -1;
        if (direction === Direction.Right) {
            nextIndex = currentIndex + 1;
        }
        else if (direction === Direction.Left) {
            nextIndex = currentIndex - 1;
        }
        if (nextIndex === -1)
            return undefined;
        const nextItem = (_a = this.props.items) === null || _a === void 0 ? void 0 : _a[nextIndex];
        if (nextItem && (this.isItemInactive(nextItem))) {
            return this.getNextItem(nextIndex, direction);
        }
        return nextItem;
    }
    changeCurrentItemValue(itemValue) {
        var _a, _b;
        (_b = (_a = this.listeners).onChange) === null || _b === void 0 ? void 0 : _b.call(_a, itemValue);
        this.changeFocusedItemValue(itemValue);
    }
    changeFocusedItemValue(focusedItemValue) {
        this.setState({ focusedItemValue });
    }
    update(state, props, listeners) {
        applyChanges(this.state, state);
        applyChanges(this.props, props);
        applyChanges(this.listeners, listeners);
    }
    isItemInactive(item) {
        return item.inactive || item.disabled;
    }
    onKeyDown(e) {
        var _a, _b, _c, _d, _e;
        const { keyCode } = e;
        if (![Key.LeftArrow, Key.RightArrow, Key.Space, Key.Enter].includes(keyCode))
            return;
        if (keyCode === Key.Space || keyCode === Key.Enter)
            e.preventDefault();
        const focusedItemValue = (_b = (_a = this.state.focusedItemValue) !== null && _a !== void 0 ? _a : this.props.currentItemValue) !== null && _b !== void 0 ? _b : 0;
        let currentIndex = (_c = this.props.items) === null || _c === void 0 ? void 0 : _c.findIndex((i) => i.value === focusedItemValue);
        currentIndex = (!currentIndex || currentIndex === -1) ? 0 : currentIndex;
        const currentItem = (_d = this.props.items) === null || _d === void 0 ? void 0 : _d[currentIndex];
        let newItem = undefined;
        if (keyCode === Key.Space && focusedItemValue) {
            return this.changeCurrentItemValue(focusedItemValue);
        }
        // Если текущий сегмент не существует, или находится в состояниях disabled/inactive
        // Находим первый возможный для выбора
        if (typeof currentItem === 'undefined' || this.isItemInactive(currentItem)) {
            newItem = (_e = this.props.items) === null || _e === void 0 ? void 0 : _e.find((x) => !this.isItemInactive(x));
        }
        else if (keyCode === Key.RightArrow) {
            newItem = this.getNextItem(currentIndex, Direction.Right);
        }
        else if (keyCode === Key.LeftArrow) {
            newItem = this.getNextItem(currentIndex, Direction.Left);
        }
        if (newItem && newItem.value)
            this.changeFocusedItemValue(newItem.value);
    }
    onClick(newValue) {
        this.changeCurrentItemValue(newValue);
    }
    onBlur() {
        this.changeFocusedItemValue(undefined);
    }
}
SegmentedControlState.initialState = {
    focusedItemValue: undefined
};

//# sourceMappingURL=SegmentedControlState.js.map
